<template>
  <div class="sidebar-container" :class="{ 'dark-mode': isDarkMode }">
    <!-- Compact sidebar (always visible) -->
    <aside class="sidebar" :class="{ 'dark-mode': isDarkMode }">
      <!-- Logo <div class="logo-icon" @click="toggleSidebar"> -->
      <div class="logo-icon"  >
        <img src="https://peelo.chat/assets/img/peelo/v2.png" alt="Logo">
      </div>

      <!-- Navigation links (icon only) -->
      <nav class="nav-menu">
        <router-link to="/dashboard" class="nav-item" :class="{ 'active': $route.path === '/dashboard' }" title="Dashboard" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
          </svg>
          <span class="tooltip-text">Dashboard</span>
        </router-link>

        <router-link to="/dashboard/chatbots" class="nav-item" :class="{ 'active': $route.path === '/dashboard/chatbots' || isChatbotPage }" title="Chatbots" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="10" rx="2"/>
            <circle cx="12" cy="5" r="2"/>
            <path d="M12 7v4"/>
            <line x1="8" y1="16" x2="8.01" y2="16"/>
            <line x1="16" y1="16" x2="16.01" y2="16"/>
          </svg>
          <span class="tooltip-text">Chatbots</span>
        </router-link>
        
        <router-link to="/dashboard/whatsapp_management" class="nav-item" :class="{ 'active': $route.path === '/dashboard/whatsapp_management' }" title="Comptes WhatsApp" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg fill="currentColor" width="24" height="24" viewBox="0 0 506.964 506.964">
            <g transform="translate(2 1)">
              <g>
                <g>
                  <path d="M252.321-1C113.83-1,1.357,111.472,1.357,249.125c0,43.646,11.751,85.613,33.574,124.223L-2,505.964l135.134-36.092
                    c39.449,20.984,80.577,32.734,119.187,32.734c136.813,0,252.643-115.83,252.643-253.482S391.652-1,252.321-1z M252.321,485.82
                    c-36.931,0-76.38-11.751-114.151-32.734l-3.357-1.679L21.502,482.462L52.557,370.83l-1.679-3.357
                    c-20.984-36.092-32.734-77.22-32.734-118.348c0-128.42,104.918-233.338,234.177-233.338
                    c130.098,0,235.856,104.918,235.856,233.338S379.902,485.82,252.321,485.82z"/>
                  <path d="M252.321,40.967c-114.99,0-208.997,93.167-208.997,208.157c0,41.128,11.751,79.738,32.734,114.151l3.357,4.197
                    L56.754,447.21l82.256-20.984l4.197,2.518c34.413,20.984,72.184,31.895,109.115,31.895c115.83,0,210.675-94.846,210.675-211.515
                    C462.997,134.134,368.151,40.967,252.321,40.967z M251.482,444.692c-33.574,0-67.987-10.911-99.882-30.216l-10.072-6.715
                    l-61.272,15.108l16.787-58.754l-6.715-10.911c-20.144-31.056-30.216-67.148-30.216-104.079
                    c0-104.918,86.452-191.37,192.21-191.37c106.597,0,193.889,86.452,193.889,191.37
                    C446.21,356.561,358.918,443.852,251.482,444.692z"/>
                  <path d="M378.223,295.289l-52.879-24.341c-7.554-3.357-15.108-0.839-20.144,5.036l-20.144,26.02
                    c-15.108-5.875-57.075-24.341-81.416-69.666l18.466-21.823c4.197-5.036,5.036-11.751,2.518-17.626l-22.662-53.718
                    c-2.518-5.875-7.554-10.072-14.269-10.072l-15.948-0.839c-6.715,0-14.269,1.679-19.305,6.715
                    c-7.554,6.715-21.823,20.984-26.02,40.289c-5.875,27.698,3.357,60.433,26.859,92.328
                    c14.269,20.144,57.915,79.738,141.849,103.239c8.393,2.518,16.787,3.357,24.341,3.357c14.269,0,27.698-4.197,39.449-10.911
                    c13.43-8.393,22.662-22.662,26.02-37.771l2.518-11.751C389.134,306.2,384.938,298.646,378.223,295.289z M367.311,321.308
                    c-2.518,10.911-9.233,20.984-18.466,26.859c-14.269,9.233-31.056,10.911-49.521,5.875
                    c-78.059-21.823-119.187-78.059-132.616-96.525c-20.144-27.698-28.538-56.236-23.502-78.898
                    c3.357-15.108,14.269-26.02,20.984-31.895c1.679-1.679,4.197-2.518,6.715-2.518l16.787,1.679l22.662,52.879l-20.144,22.662
                    c-3.357,4.197-4.197,10.911-1.679,15.948c27.698,53.718,78.059,74.702,93.167,79.738c5.875,1.679,11.751,0,15.948-5.036
                    l20.144-26.859l52.879,24.341L367.311,321.308z"/>
                </g>
              </g>
            </g>
          </svg>
          <span class="tooltip-text">Comptes WhatsApp</span>
        </router-link>

        <router-link style="display: none;" to="/dashboard/analytics" display="none" class="nav-item" :class="{ 'active': $route.path === '/dashboard/analytics' }" title="Analytics" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 20V10M18 20V4M6 20v-6" />
          </svg>
          <span class="tooltip-text">Analytics</span>
        </router-link>

        <router-link to="/dashboard/transactions" style="display: none;" class="nav-item" :class="{ 'active': $route.path === '/dashboard/transactions' }" title="Transactions" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
          <span class="tooltip-text">Transactions</span>
        </router-link>

        <router-link to="/dashboard/orders" style="display: none;" class="nav-item" :class="{ 'active': $route.path === '/dashboard/orders' }" title="Commandes" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 17l-5-5 5-5M20 17l-5-5 5-5" />
          </svg>
          <span class="tooltip-text">Commandes</span>
        </router-link>

        <router-link to="/dashboard/all-users" class="nav-item" :class="{ 'active': $route.path === '/dashboard/all-users' }" title="Abonnés" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 7a4 4 0 100-8 4 4 0 000 8z" />
          </svg>
          <span class="tooltip-text">Abonnés</span>
        </router-link>

        <button @click="navigateToEcommerce" class="nav-item nav-external" title="E-commerce Dashboard" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="8" cy="21" r="1"/>
            <circle cx="19" cy="21" r="1"/>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
          </svg>
          <span class="tooltip-text">E-commerce</span>
        </button>

        <router-link to="/dashboard/payouts" style="display: none;"  class="nav-item" :class="{ 'active': $route.path === '/dashboard/payouts' }" title="Paiements" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <line x1="2" y1="10" x2="22" y2="10" />
          </svg>
          <span class="tooltip-text">Paiements</span>
        </router-link>
      </nav>

      <!-- Bottom tools -->
      <div class="bottom-tools">
        <button class="theme-toggle" @click="$emit('toggle-theme')" title="Changer de thème" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg v-if="!isDarkMode" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="5" />
            <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
          </svg>
          <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
          </svg>
          <span class="tooltip-text">{{ isDarkMode ? 'Mode jour' : 'Mode nuit' }}</span>
        </button>
        
        <button style="display: none;" class="settings-button" title="Paramètres" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
          </svg>
          <span class="tooltip-text">Paramètres</span>
        </button>
      </div>

      <!-- Profile section -->
      <div class="profile-section">
        <button class="profile-button" @click="toggleUserMenu">
          <img :src="user?.data?.profile_picture || 'https://placehold.co/400'" alt="Profile">
          <div class="verified-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="#3B82F6" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" stroke-width="2" />
            </svg>
          </div>
        </button>
      </div>
    </aside>

    <!-- Expanded sidebar (conditionally visible) -->
    <aside v-if="isExpanded" class="expanded-sidebar" :class="{ 'dark-mode': isDarkMode }">
      <!-- Workspace info -->
      <div class="workspace-header">
        <div class="workspace-info">
          <h2 class="workspace-name">{{ user?.data?.name || 'Dashboard' }}</h2>
          <div class="workspace-url">{{ user?.data?.email || 'utilisateur@mail.com' }}</div>
        </div>
        <button class="toggle-button" @click="toggleSidebar">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
      </div>
      
      <!-- Switch stores button -->
      <div class="switch-stores">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        <span>Switch stores</span>
      </div>
      
      <!-- Main navigation -->
      <nav class="main-navigation">
        <!-- Main navigation items -->
        <router-link to="/dashboard/products" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="3" width="20" height="18" rx="2" ry="2"/>
            <line x1="8" y1="3" x2="8" y2="21"/>
          </svg>
          <span>Products</span>
        </router-link>
        
        <router-link to="/dashboard/analytics" style="display: none;" class="menu-item" :class="{ 'active': $route.path === '/dashboard/analytics' }">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 20V10M18 20V4M6 20v-6"/>
          </svg>
          <span>Analytics</span>
        </router-link>
        
        <router-link to="/dashboard/transactions" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
          </svg>
          <span>Transactions</span>
        </router-link>
        
        <router-link to="/dashboard/orders" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
            <path d="M9 12h6M9 16h6"/>
          </svg>
          <span>Orders</span>
        </router-link>
        
        <router-link to="/dashboard/all-users" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <span>Subscribers</span>
        </router-link>
        
        <button @click="navigateToEcommerce" class="menu-item nav-external">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="8" cy="21" r="1"/>
            <circle cx="19" cy="21" r="1"/>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
          </svg>
          <span>E-commerce Dashboard</span>
        </button>
        
        <router-link to="/dashboard/payouts" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="5" width="20" height="14" rx="2"/>
            <line x1="2" y1="10" x2="22" y2="10"/>
          </svg>
          <span>Payouts</span>
        </router-link>
        
        <!-- Posts section with dropdown -->
        <div class="menu-section">
          <div class="section-header">
            <router-link to="/dashboard/posts" class="menu-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
              <span>Posts</span>
            </router-link>
            <button class="add-button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="12" y1="5" x2="12" y2="19"/>
                <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </button>
          </div>
          
          <!-- Submenu items -->
          <div class="submenu">
            <router-link to="/dashboard/posts/drafts" class="submenu-item">
              <span>Drafts</span>
              <div class="counter">10</div>
            </router-link>
            <router-link to="/dashboard/posts/scheduled" class="submenu-item">
              <span>Scheduled</span>
              <div class="counter">2</div>
            </router-link>
            <router-link to="/dashboard/posts/published" class="submenu-item">
              <span>Published</span>
              <div class="counter">28</div>
            </router-link>
          </div>
        </div>
        
        <!-- Pages section with dropdown -->
        <div class="menu-section">
          <div class="section-header">
            <router-link to="/dashboard/pages" class="menu-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                <path d="M14 2v6h6"/>
                <path d="M16 13H8"/>
                <path d="M16 17H8"/>
                <path d="M10 9H8"/>
              </svg>
              <span>Pages</span>
            </router-link>
            <button class="add-button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="12" y1="5" x2="12" y2="19"/>
                <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Other menu items -->
        <router-link to="/dashboard/performance" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
          </svg>
          <span>Performance</span>
        </router-link>
        
        <router-link to="/dashboard/team" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 00-3-3.87"/>
            <path d="M16 3.13a4 4 0 010 7.75"/>
          </svg>
          <span>Team management</span>
        </router-link>
        
        <router-link to="/dashboard/customize" class="menu-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/>
          </svg>
          <span>Customize</span>
        </router-link>
      </nav>
    </aside>

    <!-- User Menu Popup au niveau racine -->
    <div v-if="showUserMenu" class="user-menu">
       <div class="user-info">
        <img :src="user?.profile_picture || 'https://placehold.co/400'" alt="Profile" class="menu-avatar">
        <div class="user-details">
          <span class="user-name">{{ user?.name || 'Utilisateur' }}</span>
          <span class="user-email">{{ user?.email || 'utilisateur@mail.com' }}</span>
        </div>
        <div class="verified-badge blue">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#3B82F6" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" stroke-width="2" />
          </svg>
        </div>
      </div>
      <div class="menu-items">
        <div class="menu-item" @click="goToProfile">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <span>Voir profil</span>
        </div>
        <div class="menu-item" @click="goToAccountSettings">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
            </svg>
          </div>
          <span>Paramètres du compte</span>
        </div>
        <div class="menu-item" @click="$emit('toggle-theme')">
          <div class="menu-icon">
            <svg v-if="!isDarkMode" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="5" />
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
            </svg>
            <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
            </svg>
          </div>
          <span>{{ isDarkMode ? 'Mode jour' : 'Mode nuit' }}</span>
        </div>
        <div class="menu-item" @click="logout">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </div>
          <span>Déconnexion</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { ecommerceDashboardUrl } from '@/config';

export default {
  name: 'Sidebar',
  props: {
    isDarkMode: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    }
  },
  emits: ['toggle-sidebar', 'logout', 'toggle-theme'],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const showUserMenu = ref(false);
    const isExpanded = ref(false);

    // Determine if we're on a chatbot page
    const isChatbotPage = computed(() => {
      return route.path.includes('/dashboard/chatbots/') && route.params.id;
    });

    // Get the chatbot ID
    const chatbotId = computed(() => {
      return route.params.id;
    });

    // Toggle user menu
    const toggleUserMenu = () => {
      showUserMenu.value = !showUserMenu.value;
    };

    // Toggle sidebar
    const toggleSidebar = () => {
      isExpanded.value = !isExpanded.value;
      localStorage.setItem('sidebarExpanded', isExpanded.value);
      emit('toggle-sidebar', isExpanded.value);
    };

    // Tooltips positioning
    const showTooltip = (event) => {
      const tooltip = event.currentTarget.querySelector('.tooltip-text');
      if (tooltip) {
        const rect = event.currentTarget.getBoundingClientRect();
        
        // Position fixe pour être toujours au-dessus de tous les éléments
        tooltip.style.position = 'fixed';
        
        // Si la barre latérale est étendue, positionner les tooltips plus à droite
        if (isExpanded.value) {
          // Position à droite de la barre latérale étendue (64px sidebar + 240px expanded + 10px marge)
          tooltip.style.left = `314px`;
        } else {
          // Position normale à droite de l'élément
          tooltip.style.left = `${rect.right + 10}px`;
        }
        
        // La position verticale reste la même
        tooltip.style.top = `${rect.top + (rect.height / 2)}px`;
        
        // Ajouter la classe visible
        tooltip.classList.add('visible');
      }
    };

    const hideTooltip = (event) => {
      const tooltip = event.currentTarget.querySelector('.tooltip-text');
      if (tooltip) {
        tooltip.classList.remove('visible');
      }
    };

    // Logout function
    const logout = () => {
      localStorage.removeItem('token');
      router.push('/login');
      emit('logout');
      showUserMenu.value = false;
    };

    // Close user menu when clicking outside
    if (typeof window !== 'undefined') {
      window.addEventListener('click', (e) => {
        const menu = document.querySelector('.user-menu');
        const button = document.querySelector('.profile-button');
        if (showUserMenu.value && menu && !menu.contains(e.target) && button && !button.contains(e.target)) {
          showUserMenu.value = false;
        }
      });
    }

    // Watch for route changes to close the user menu
    watch(
      () => route.path,
      () => {
        showUserMenu.value = false;
      }
    );

    // New methods for profile navigation
    const goToProfile = () => {
      router.push('/dashboard/profile');
      showUserMenu.value = false;
    };

    const goToAccountSettings = () => {
      router.push('/dashboard/account-settings');
      showUserMenu.value = false;
    };

    const navigateToEcommerce = () => {
      // Récupérer les données utilisateur depuis localStorage
      const userData = localStorage.getItem('user');
      if (!userData) {
        console.error('Données utilisateur non trouvées');
        // Rediriger vers l'e-commerce sans données
        window.open(ecommerceDashboardUrl, '_blank');
        return;
      }
      
      try {
        // Importer la fonction de cryptage
        import('@/utils/crypto.js').then(({ encryptUserData }) => {
          // Crypter les données utilisateur
          const encryptedData = encryptUserData(userData);
          
          // Construire l'URL avec les données cryptées
          const autoconnectUrl = `${ecommerceDashboardUrl}/autoconnect/${encryptedData}`;
          console.log('🔗 autoconnectUrl ====>',autoconnectUrl)
          console.log('🔗 Redirection vers l\'e-commerce avec auto-login sécurisé');
          window.open(autoconnectUrl, '_blank');
        }).catch(error => {
          console.error('Erreur lors du cryptage des données:', error);
          // Fallback sans cryptage
          window.open(ecommerceDashboardUrl, '_blank');
        });
      } catch (error) {
        console.error('Erreur lors de la préparation de la redirection:', error);
        // Fallback sans cryptage
        window.open(ecommerceDashboardUrl, '_blank');
      }
    };

    return {
      isChatbotPage,
      chatbotId,
      showUserMenu,
      toggleUserMenu,
      isExpanded,
      toggleSidebar,
      logout,
      showTooltip,
      hideTooltip,
      goToProfile,
      goToAccountSettings,
      navigateToEcommerce
    };
  }
};
</script>

<style scoped>
/* Base container */
.sidebar-container {
  display: flex;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
}

/* Compact sidebar */
.sidebar {
  width: 64px;
  height: 100vh;
  background: #F9FAFB;
  border-right: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  z-index: 10;
}

.sidebar.dark-mode {
  background: #111827;
  border-right-color: #374151;
}

/* Logo */
.logo-icon {
  width: 40px;
  height: 40px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.dark-mode .logo-icon {
  background: #1F2937;
  border-color: #374151;
}

.logo-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* Navigation menu */
.nav-menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px;
  flex: 1;
  overflow-y: auto;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  color: #6B7280;
  text-decoration: none;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nav-item:hover {
  background-color: #F3F4F6;
  color: #111827;
}

.nav-item.active {
  background-color: #F3F4F6;
  color: #111827;
}

.nav-item.nav-external {
  border: 1px solid #E5E7EB;
}

.nav-item.nav-external:hover {
  border-color: #3B82F6;
  color: #3B82F6;
}

.dark-mode .nav-item {
  color: #9CA3AF;
}

.dark-mode .nav-item:hover {
  background-color: #1F2937;
  color: #F9FAFB;
}

.dark-mode .nav-item.active {
  background-color: #1F2937;
  color: #F9FAFB;
}

/* Bottom tools */
.bottom-tools {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.theme-toggle,
.settings-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: #6B7280;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.theme-toggle:hover,
.settings-button:hover {
  background-color: #F3F4F6;
  color: #111827;
}

.dark-mode .theme-toggle,
.dark-mode .settings-button {
  color: #9CA3AF;
}

.dark-mode .theme-toggle:hover,
.dark-mode .settings-button:hover {
  background-color: #1F2937;
  color: #F9FAFB;
}

/* Profile section */
.profile-section {
  padding: 0 12px;
  position: static;
}

.profile-button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: white;
  border: 1px solid #E5E7EB;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;
}

.dark-mode .profile-button {
  background: #1F2937;
  border-color: #374151;
}

.profile-button:hover {
  border-color: #D1D5DB;
}

.profile-button img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.verified-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 14px;
  height: 14px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.verified-badge.blue {
  position: static;
  margin-left: auto;
}

/* Expanded sidebar */
.expanded-sidebar {
  position: absolute;
  left: 64px;
  top: 0;
  width: 240px;
  height: 100vh;
  background: white;
  border-right: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  z-index: 20;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.05);
}

.expanded-sidebar.dark-mode {
  background: #1F2937;
  border-right-color: #374151;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.3);
}

/* Workspace header */
.workspace-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px;
  border-bottom: 1px solid #E5E7EB;
}

.dark-mode .workspace-header {
  border-bottom-color: #374151;
}

.workspace-info {
  overflow: hidden;
}

.workspace-name {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.workspace-url {
  font-size: 12px;
  color: #6B7280;
}

.dark-mode .workspace-name {
  color: #F9FAFB;
}

.dark-mode .workspace-url {
  color: #9CA3AF;
}

.toggle-button {
  background: transparent;
  border: none;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  cursor: pointer;
}

.dark-mode .toggle-button {
  color: #9CA3AF;
}

/* Switch stores */
.switch-stores {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 8px;
  color: #6B7280;
  font-size: 14px;
  cursor: pointer;
}

.switch-stores:hover {
  color: #111827;
}

.dark-mode .switch-stores {
  color: #9CA3AF;
}

.dark-mode .switch-stores:hover {
  color: #F9FAFB;
}

/* Main navigation */
.main-navigation {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.main-navigation .menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  color: #374151;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.main-navigation .menu-item:hover {
  background-color: #F3F4F6;
}

.main-navigation .menu-item.active {
  background-color: #F3F4F6;
  color: #111827;
}

.dark-mode .main-navigation .menu-item {
  color: #D1D5DB;
}

.dark-mode .main-navigation .menu-item:hover {
  background-color: #374151;
}

.dark-mode .main-navigation .menu-item.active {
  background-color: #374151;
  color: #F9FAFB;
}

.menu-item svg {
  color: #6B7280;
  flex-shrink: 0;
}

.dark-mode .menu-item svg {
  color: #9CA3AF;
}

/* Section headers */
.menu-section {
  margin-bottom: 4px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 12px;
}

.section-header .menu-item {
  flex: 1;
}

.add-button {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #6B7280;
  cursor: pointer;
  border-radius: 4px;
  padding: 0;
}

.add-button:hover {
  background-color: #F3F4F6;
}

.dark-mode .add-button {
  color: #9CA3AF;
}

.dark-mode .add-button:hover {
  background-color: #374151;
}

/* Submenu */
.submenu {
  padding-left: 48px;
}

.submenu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px 6px 0;
  color: #374151;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
}

.submenu-item:hover {
  color: #111827;
}

.dark-mode .submenu-item {
  color: #D1D5DB;
}

.dark-mode .submenu-item:hover {
  color: #F9FAFB;
}

.counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #F3F4F6;
  color: #6B7280;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.dark-mode .counter {
  background: #374151;
  color: #9CA3AF;
}

/* Navigation item tooltip */
.nav-item, .theme-toggle, .settings-button {
  position: relative;
}

.tooltip-text {
  visibility: hidden;
  position: fixed;
  left: 110%;
  top: 50%;
  transform: translateY(-50%);
  background-color: #1F2937;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 40000000000; /* Z-index très élevé pour être au-dessus de tout */
}

.tooltip-text::before {
  content: '';
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent #1F2937 transparent transparent;
}

.tooltip-text.visible {
  position: fixed !important;
  z-index: 99999 !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.dark-mode .tooltip-text {
  background-color: #374151;
  color: #F9FAFB;
}

.dark-mode .tooltip-text::before {
  border-color: transparent #374151 transparent transparent;
}

/* User menu */
.user-menu {
  position: fixed;
  left: 65px;
  bottom: 12px;
  width: 250px;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 30000;
}

.dark-mode .user-menu {
  background: #1F2937;
  border-color: #374151;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.user-info {
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #E5E7EB;
}

.dark-mode .user-info {
  border-bottom-color: #374151;
}

.menu-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

.user-email {
  display: block;
  font-size: 12px;
  color: #6B7280;
  margin-top: 1px;
}

.dark-mode .user-name {
  color: #F9FAFB;
}

.dark-mode .user-email {
  color: #9CA3AF;
}

.menu-items {
  padding: 4px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: #374151;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.menu-item:hover {
  background-color: #F3F4F6;
}

.dark-mode .menu-item {
  color: #D1D5DB;
}

.dark-mode .menu-item:hover {
  background-color: #374151;
}

.menu-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
}

.dark-mode .menu-icon {
  color: #9CA3AF;
}

.shortcut {
  display: none;
}
</style> 